import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import useStyles from '../../styles/ActionBar/ActionBarStyles';

import Grid from '@material-ui/core/Grid';

function importActionElement(element) {
  return lazy(() => import(`../actionbar/${element}`).catch(() => import('../shared/NullElement')));
}

/**
 * ActionBar
 *
 * Renders a config object in the form:
 *
 *    actionBar: [
 *      {
 *        type: 'button',
 *        component: 'AddDataCollectionButton',
 *      },
 *      {
 *        type: 'button',
 *        component: 'DeleteDataCollectionButton',
 *      },
 *    ],
 */
function ActionBar({ slice }) {
  const actionElements = useSelector(
    (state) => slice.selectors.selectActiveTab(state).actionBar || []
  );
  const classes = useStyles();

  function buildActionElements(item, idx) {
    const Component = importActionElement(item.component);
    return (
      <Grid item key={idx} className={classes.container}>
        <Suspense fallback={<></>}>
          <Component {...item.props} />
        </Suspense>
      </Grid>
    );
  }

  return (
    <Grid container alignItems="center">
      {actionElements.map((actionElement, idx) => buildActionElements(actionElement, idx))}
    </Grid>
  );
}

export default ActionBar;
